import { DestinationDto } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllDestinationsResponseModel extends GlobalResponseObject {
    data?: DestinationDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /ProductDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: DestinationDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

